
export const ProfileRoleConstants = {
    RoleIdDefault: 'Default',
    RoleIdAdmin: 'Administrator',
    RoleIdNone: '',
    
    RoleDefaultDisplayName: $localize`Standardbenutzer`,
    RoleAdminDisplayName: $localize`Administrator`,
    RoleNoneDisplayName: $localize`Nicht vergeben`
}

export class ProfileRole {
    public Id: string;
    public DisplayName: string;
}
